<div class="content" (click)="onMouseClick($event)">
    <div class="skip-section">
        <div (click)="skipsection()" class="skip-rectangle">
            <div class="skip-text-content">
                <span class="skip-text">Skip this section for now</span>
                <span><fa-icon class="fa-2x skip-icon" [icon]='faChevronCircleRight'></fa-icon></span>
            </div>
        </div>
    </div>
    <!-- <form> -->
    <div class="row-1">
        <div class="flex-column">
            <div class="column-container">
                <div class="column-content">
                    <div class="formgroup">
                        <span><label>Site</label>
                            <fa-icon [icon]='faInfoCircle' class="info" id="SiteInfoBtn"  (mouseleave)="showHideInfoToggle()" (mouseenter)="showHideInfoToggle()"></fa-icon>
                            <div id="SiteInfo" >
                                <div class="InfoContent">
                                  Enter the info that customer uses for the identification of the place being analysed.
                                </div>
                                <div id="arrow" data-popper-arrow></div>
                            </div>
                        </span>
                        <!-- <input type="text" class="input-field" placeholder="For eg. XYZ Site" name="siteName" formControlName="siteName" (change)= "detectChanges($event)" (keydown)="sharedService.preventTabKey($event)"> -->
                        <input type="text" class="input-field" placeholder="For eg. XYZ Site" name="siteName" [(ngModel)]="siteinfo.siteName" (change)= "detectChanges($event)" maxlength="100">
                    </div>
                    <div class="formgroup">
                        <label>Location</label>
                        <!-- <input type="text" class="input-field" name="location" formControlName="location" (change)= "detectChanges($event)" (keydown)="sharedService.preventTabKey($event)"> -->
                        <input type="text" class="input-field" name="location" [(ngModel)]="siteinfo.location" (change)= "detectChanges($event)" maxlength="100">
                    </div>
                    <div class="formgroup">
                        <span>
                            <label>Building</label>
                        </span>
                        <!-- <input type="text" name="building" formControlName="building" class="input-field" (change)= "detectChanges($event)" (keydown)="sharedService.preventTabKey($event)" > -->
                        <input type="text" name="building" [(ngModel)]="siteinfo.building" class="input-field" (change)= "detectChanges($event)" maxlength="100">
                    </div>
                    <div class="formgroup">
                        <label>Room</label>
                        <!-- <input type="text" class="input-field" name="room" formControlName="room" (change)= "detectChanges($event)" (change)= "detectChanges($event)" (keydown)="sharedService.preventTabKey($event)"> -->
                        <input type="text" class="input-field" name="room" [(ngModel)]="siteinfo.room" (change)= "detectChanges($event)" maxlength="255">
                    </div>
                    <div class="formgroup">
                      <label>AHU</label>
                      <!-- <input type="text" class="input-field" name="ahu" formControlName="ahu" (change)= "detectChanges($event)" (change)= "detectChanges($event)" (keydown)="sharedService.preventTabKey($event)"> -->
                      <input type="text" class="input-field" name="ahu" [(ngModel)]="siteinfo.ahu" (change)= "detectChanges($event)" maxlength="100">
                  </div>
                </div>
            </div>
            <div class="column-container">
                <div class="column-content">
                    <div class="formgroup">
                        <label>Description</label>
                          <!-- <input type="textarea" class="inputtext-field" name="desc" formControlName="desc" (change)= "detectChanges($event)" (keydown)="sharedService.preventTabKey($event)"> -->
                          <!-- Modified by PP(2023-04-05) : To use multiline input <input type="textarea" class="inputtext-field" name="desc" [(ngModel)]="siteinfo.siteDesc" (change)= "detectChanges($event)"> -->
                          <textarea class="inputtext-field" rows="3" cols="50" name="desc" [(ngModel)]="siteinfo.siteDesc" (change)= "detectChanges($event)" maxlength="255">

                          </textarea>
                    </div>
                </div>
            </div>
        </div>
    </div>

        <div class="next-button-content">
            <button class="button-content ripple" (click)='next()'>
                <span class='space'>Next</span> <fa-icon [icon]="faAngleRight"></fa-icon>
            </button>
        </div>
  </div>
  
  
  